import { ReactElement } from 'react';
import { Loading } from 'components/Loading';
import './index.less';

export const BetslipPreloadState = (): ReactElement => {
  return (
    <div className="betslip__preloadState">
      <Loading />
    </div>
  );
};
